// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2msdx","gfeWrapper":"CalendarEvent_gfeWrapper__19ZKe"};